var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,35V16h40v11h2V11c0-2.7568359-2.2431641-5-5-5h-3V2h-2v4H10V2H8v4H5c-2.7568359,0-5,2.2431641-5,5v24 c0,2.7568359,2.2431641,5,5,5h21v-2H5C3.3457031,38,2,36.6542969,2,35z M2,11c0-1.6542969,1.3457031-3,3-3h3v4h2V8h24v4h2V8h3 c1.6542969,0,3,1.3457031,3,3v3H2V11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,28c-5.5136719,0-10,4.4863281-10,10s4.4863281,10,10,10s10-4.4863281,10-10S43.5136719,28,38,28z M38,46 c-4.4111328,0-8-3.5888672-8-8s3.5888672-8,8-8s8,3.5888672,8,8S42.4111328,46,38,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,32h-2v5.3818359c0,0.7636719,0.4238281,1.4492188,1.1054688,1.7890625l3.4472656,1.7236328l0.8945312-1.7890625 L39,37.3818359V32z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentMedium);
export default __webpack_public_path__ + "static/media/appointment--medium.59d1ded7ab4fea9fe77fef4629d1d3e9.svg";
export { ForwardRef as ReactComponent };